import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularBell: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_bell"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="bell icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.75 2.75C12.75 2.33579 12.4142 2 12 2C11.5858 2 11.25 2.33579 11.25 2.75V3.62714C9.04282 3.80114 7.4779 4.73934 6.45014 5.92332C5.33409 7.209 4.87109 8.7618 4.87109 9.85966V18.1074H4.25C3.83579 18.1074 3.5 18.4432 3.5 18.8574C3.5 19.2716 3.83579 19.6074 4.25 19.6074H9.65527V19.8141C9.65527 21.0934 10.781 22.0001 12 22.0001C13.2191 22.0001 14.3448 21.0934 14.3448 19.8141V19.6074H19.75C20.1642 19.6074 20.5 19.2716 20.5 18.8574C20.5 18.4432 20.1642 18.1074 19.75 18.1074H19.1292V9.85966C19.1292 8.7618 18.6662 7.209 17.5502 5.92332C16.5224 4.73928 14.9574 3.80105 12.75 3.62711V2.75ZM17.6292 18.1074V9.85966C17.6292 9.12035 17.2949 7.91739 16.4174 6.90661C15.5645 5.92408 14.1771 5.09814 12.0002 5.09814C9.82319 5.09814 8.43578 5.92408 7.58289 6.90661C6.70548 7.91739 6.37109 9.12035 6.37109 9.85966V18.1074H17.6292ZM11.1553 19.8141V19.6074H12.8448V19.8141C12.8448 20.1209 12.5425 20.5001 12 20.5001C11.4576 20.5001 11.1553 20.1209 11.1553 19.8141Z"
        />
      </svg>
    </span>
  );
};

export { RegularBell };
